// Uppercase with underscores (SCREAMING_SNAKE_CASE): This is the standard convention for global constants in JavaScript/TypeScript.

export const ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'

export const UNIX_FORMAT = 'X'

export const UNIX_FORMAT_MS = 'x'

export const TIME_FORMAT = 'HH:mm'

export const TIME_FORMAT_LOCAL = 'LT'

export const TIME_FORMAT_LOCAL_WITH_SECONDS = 'LTS'

export const TIME_FORMAT_FULL = 'HH:mm:ss'

export const DATE_FORMAT = 'DD.MM.YYYY'
export const DATE_FORMAT_SHORT = 'DD.MM.YY'

export const DATE_FORMAT_EN = 'MM/DD/YYYY'
export const DATE_FORMAT_EN_SHORT = 'MM/DD/YY'

export const DATE_FORMAT_LOCAL = 'L'

export const DATE_FORMAT_SERVER = 'YYYY-MM-DD'

export const DATE_TIME_FORMAT = 'L, LT'

export const DATE_TIME_FORMAT_SERVER = 'YYYY-MM-DD HH:mm:ss'
